import { Form, BaseModel, OneColumnLayout, Entry, EntryTypes, CardMode, Resource } from '@ngx-resource-toolkit/core';
import { Validators } from '@angular/forms';
import { LeaResource } from '../../resource/lea.resource';
import { TABLE } from '../../../app.constantes';
import { environment } from '../../../../environments/environment';
import { ExamenMentionModel } from './examen-mention.model';
import { ExamenResultatJuryModel } from './examen-resultat-jury.model';

const NB_NOTES_NUMERIQUES = 8;
const NB_NOTES_MENTIONS = 10;

const compareMentionFn = (one, two) => {
	return one && two && +one.id === +two.id;
};
const transformMention = (value, row) => {
	// Pour le moment, le libellé court n'ayant pas été récupéré, on prend le libellé long
	return (value) ? (value.libelleCourt ? value.libelleCourt : value.libelle) : '';
};
const optionsDispenses = [{
	label: '', // 'Dispensé',
	value: true,
	disabled: false,
}];
const cssLabel = 'col-xs-5';
const normalCss = {
	group: 'col-xs-12',
	label: cssLabel,
	input: 'col-xs-7'
};
const normalCheckCss = {
	group: 'col-xs-12',
	label: cssLabel,
	input: 'col-xs-6'
};
@Resource({
	modes: {
		'default': {
			url: environment.proxyUrl + '/examen',
			methods: LeaResource.methods
		}
	}
})
	@Form({
		'consult': { // Mode consultation
			layout: OneColumnLayout,
		},
		'edit': { // Mode modification (création/modification)
			layout: OneColumnLayout,
		},
		'table': {},
		'table_fiche_eleve': {},
	})
export class ExamenResultatModel extends BaseModel {

	// Libellés de l'examen (: alculé à partir des données de examen (paramétrage)
	@Entry({
		base: {
			type: EntryTypes.STATIC,
			hidden: true, // On a mis le champ pour avoir le titre mais il sera affiché manuellement
		},
		'consult': {},
		'edit': {},
		'table_fiche_eleve': {
			hidden: false,
			colOrder: 1,
		},
		'table_historique_eleve': {
			hidden: false,
			colOrder: 2,
			minWidth: TABLE.MIN_WIDTH.EXAMEN,
		}
	})
	libelleExamen: string;

	@Entry({
		base: {
			css: normalCheckCss,
			label: 'Dispensé',
			type: EntryTypes.CHECKBOX,
			// options: optionsDispenses,
			options: [{
				label: '', // 'Dispensé',
				value: true,
				disabled: true,
			}]
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
				group: '',
				label: '',
				input: '',
			},
			colOrder: 26,
			minWidth: TABLE.MIN_WIDTH.BOOLEAN,
			flexGrow: 1,
			isEditable: false,
			transform: (value, row) => (value) ? 'X' : '',
			options: [{
				label: '', // 'Dispensé',
				value: true,
				disabled: false,
			}]
		},
	})
	isDispense: boolean; // Dispense de passer l'examen => pas de changement de niveau

	// #################
	// Notes numériques
	// #################
	@Entry({
		base: {
			type: EntryTypes.TEL,
			hidden: true, // L'affichage sera activé en fonction du paraméteage
			// Le label sera déterminé en fontion du paramétrage (TypeNotation)
			// Les borndes min et max seront à fixer en fonction du paramétrage (TypeNotation)
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
		},
		'table': {
			colOrder: 11,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
			isEditable: true,
		},
	})
	note_1: number;

	@Entry({
		base: {
			type: EntryTypes.TEL,
			hidden: true,
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
		},
		'table': {
			colOrder: 12,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
			isEditable: true,
		},
	})
	note_2: number;

	@Entry({
		base: {
			type: EntryTypes.TEL,
			hidden: true,
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
		},
		'table': {
			colOrder: 13,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
			isEditable: true,
		},
	})
	note_3: number;

	@Entry({
		base: {
			type: EntryTypes.TEL,
			hidden: true,
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
		},
		'table': {
			colOrder: 14,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
			isEditable: true,
		},
	})
	note_4: number;

	@Entry({
		base: {
			type: EntryTypes.TEL,
			hidden: true,
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
		},
		'table': {
			colOrder: 15,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
			isEditable: true,
		},
	})
	note_5: number;

	@Entry({
		base: {
			type: EntryTypes.TEL,
			hidden: true,
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
		},
		'table': {
			colOrder: 16,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
			isEditable: true,
		},
	})
	note_6: number;

	@Entry({
		base: {
			type: EntryTypes.TEL,
			hidden: true,
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
		},
		'table': {
			colOrder: 17,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
			isEditable: true,
		},
	})
	note_7: number;

	@Entry({
		base: {
			type: EntryTypes.TEL,
			hidden: true,
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
		},
		'table': {
			colOrder: 18,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
			isEditable: true,
		},
	})
	note_8: number;

	@Entry({
		base: {
			hidden: true,
			label: 'Total',
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
			type: EntryTypes.STATIC,
		},
		'table': {
			colOrder: 19,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
		},
	})
	note_totale: number;

	@Entry({
		base: {
			hidden: true,
			label: 'Moyenne',
			css: normalCss,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
			type: EntryTypes.STATIC,
		},
		'table': {
			colOrder: 20,
			minWidth: TABLE.MIN_WIDTH.NOTE,
			flexGrow: 1,
		},
	})
	note_moyenne: number;

	@Entry({
		base: {
			css: normalCss,
			label: 'Mention',
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
            nested: false,
            type: EntryTypes.SELECT,
            css: {
                input: '',
                group: '',
            },
            isEditable: false,
			colOrder: 25,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			transform: transformMention, // (value, row) => (value) ? (value.libelle ? value.libelle : value) : '',
		},
	})
	mentionCalculee: ExamenMentionModel;
	ptsNextMention: Number;


	// ###############
	// Notes mentions
	// ###############
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
			type: EntryTypes.SELECT,
			compareFn: compareMentionFn, // (one, two) => one && two && one.id === two.id,
			colOrder: 31,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention, // (value, row) => (value) ? (value.libelle ? value.libelle : value) : '',
		},
	})
	mention_1: ExamenMentionModel;

	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 32,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_2: ExamenMentionModel;
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 33,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_3: ExamenMentionModel;
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 34,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_4: ExamenMentionModel;
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 35,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_5: ExamenMentionModel;
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 36,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_6: ExamenMentionModel;
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 37,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_7: ExamenMentionModel;
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 38,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_8: ExamenMentionModel;
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 39,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_9: ExamenMentionModel;
	@Entry({
		base: {
			css: normalCss,
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			css: {
                input: '',
                group: '',
            },
			nested: false,
            type: EntryTypes.SELECT,
			compareFn: compareMentionFn,
			colOrder: 40,
			minWidth: TABLE.MIN_WIDTH.NOTE_MENTION,
			flexGrow: 2,
			isEditable: true,
			transform: transformMention,
		},
	})
	mention_10: ExamenMentionModel;

	@Entry({
		base: {
			css: normalCss,
			/*{
				group: 'col-xs-12',
				label: cssLabel,
				input: 'col-xs-12'
			},*/
			hidden: true,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
			type: EntryTypes.TEXTAREA,
		},
	})
	libre_1: string;

	@Entry({
		base: {
			label: 'Commentaires',
			css: {
				group: 'col-xs-12',
				label: cssLabel,
				input: 'col-xs-12'
			},
			type: EntryTypes.STATIC,
		},
		'consult': {
			type: EntryTypes.STATIC,
		},
		'edit': {
			type: EntryTypes.TEXTAREA,
		},
	})
	commentaire: string;

	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {
			colOrder: -1,
			// hidden: false, // pour les tests
		}
	})
	id: number;
	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	idExamen: number;
	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	idEleve: number;
	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	idDiscipline: number;

	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'table_fiche_eleve': {
			hidden: false,
			colOrder: 2,
		},
		'table_historique_eleve': {
			hidden: false,
			colOrder: 3,
			minWidth: TABLE.MIN_WIDTH.DISCIPLINE
		}
	})
	libelleDiscipline: string;

	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	idCycle: number;
	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	idNiveau: number;

	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
	})
	idTypeNotation: number;
	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {},
		'table_historique_eleve': {
			hidden: false,
			colOrder: 1,
			minWidth: TABLE.MIN_WIDTH.ID
		}
	})
	anneeScolaire: number;

	@Entry({
		base: {
			css: {
				group: 'col-xs-12',
				// label: cssLabel,
				// input: 'col-xs-8'
			},
			nested: true,
		},
		'consult': {},
		'edit': {},
		'table': {
			hidden: true,
		}
	})
	resultatJury: ExamenResultatJuryModel;



	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	idCursus: number;

	idTypeDiscipline: number;
	@Entry({
		base: {
			label: 'Cycle',
			type: EntryTypes.STATIC,
		},
		'table': {
			colOrder: 1,
			minWidth: TABLE.MIN_WIDTH.CYCLE,
			hidden: true,
		},
		'table_fiche_eleve': {
			colOrder: 3,
		},
		'table_historique_eleve': {
			hidden: true, // La colonne libelleCycleNiveau suffit
			colOrder: 4,
			minWidth: TABLE.MIN_WIDTH.NIVEAU,
			flexGrow: 2,
		}
	})
	libelleCycle: string;
	@Entry({
		base: {
			label: 'Niveau',
			type: EntryTypes.STATIC,
		},
		'table': {
			colOrder: 2,
			minWidth: TABLE.MIN_WIDTH.NIVEAU,
			hidden: true,
		},
		'table_fiche_eleve': {
			colOrder: 4,
		},
		'table_historique_eleve': {
			hidden: true, // La colonne libelleCycleNiveau suffit
			colOrder: 5,
			minWidth: TABLE.MIN_WIDTH.NIVEAU,
			flexGrow: 2,
		}
	})
	libelleNiveau: string;
	@Entry({
		base: {
			label: 'Niveau',
			type: EntryTypes.STATIC,
			hidden: true,
		},
		'table': {
			colOrder: 2,
			minWidth: TABLE.MIN_WIDTH.NIVEAU,
			hidden: false,
		},
		'table_fiche_eleve': {
			colOrder: 4,
		},
		'table_historique_eleve': {
			hidden: false,
			colOrder: 5,
			minWidth: TABLE.MIN_WIDTH.NIVEAU,
			flexGrow: 2,
		}
	})
	libelleCycleNiveau: string;
	@Entry({
		base: {
			label: 'An',
			type: EntryTypes.STATIC,
		},
		'table': {
			colOrder: 3,
			minWidth: TABLE.MIN_WIDTH.SMALL_INT,
			flexGrow: 1,
		},
		'table_fiche_eleve': {
			colOrder: 5,
		},
		'table_historique_eleve': {
			hidden: false,
			colOrder: 6,
			minWidth: TABLE.MIN_WIDTH.AN
		}
	})
	nbAnneesDansCycle: number;

	@Entry({
		base: {
			label: 'An',
			type: EntryTypes.STATIC,
		},
		'table': {
			colOrder: 56,
			minWidth: TABLE.MIN_WIDTH.SMALL_INT,
			flexGrow: 1,
			transform: (value, row) => {
				return value ? value : '';
			},
		},
	})
	nbAnneesDansCycleAnneeSuivante: number;

	@Entry({
		base: {
			label: 'Professeur',
			type: EntryTypes.STATIC,
		},
		'consult': {
			hidden: true,
		},
		'table': {
			colOrder: 4,
			minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
			flexGrow: 3,
		},
		'table_fiche_eleve': {
			colOrder: 6,
		},
		'table_historique_eleve': {
			hidden: false,
			colOrder: 7,
			minWidth: TABLE.MIN_WIDTH.NOM_PRENOM
		}
	})
	libelleProfesseur: string;
	@Entry({
		base: {
			label: 'Elève',
			type: EntryTypes.STATIC,
		},
		'table': {
			colOrder: 5,
			minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
			flexGrow: 3,
		},
	})
	eleveLibelle: string;
	// Examen_resultat


	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	isMentionCalculeeManuel: boolean = false;

	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {
			hidden: false, // TODO afficher uniquement si c'est un examen
			label: 'Passage',
			transform: (value, row) => value ? 'X' : '',
			colOrder: 50,
		}
	})
	isChangementNiveau: boolean;

	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	idFuturCycle: number;
	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {}
	})
	idFuturNiveau: number;
	@Entry({
		base: {
			label: 'Futur niveau',
			type: EntryTypes.STATIC,
		},
		'table': {
			hidden : false,
			colOrder: 55,
			minWidth: TABLE.MIN_WIDTH.NIVEAU,
			flexGrow: 2,
		},
	})
	libelleFuturNiveau: string;

	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {},
	})
	isValide: boolean;


	// eleveDateNaissanceStr: string; //Utilise pour les editions
	// eleveAge: number;


	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'consult': {},
		'edit': {},
		'table': {},
	})
	isRedoublant: boolean;




	// Les données suivantes sont spécifiques pour la consultation et l'historique (données calculées directement avec la requête)
	// libelleAnnee: string;
	@Entry({
		base: {
			hidden: true,
			type: EntryTypes.STATIC,
		},
		'table_fiche_eleve': {
			// Trop gros pour afficher tel quel, on le vois en cliquant sur >. Sinon il faudrait afficher les premiers caractères uniquement.
			hidden: true,
			colOrder: 7,
		},
		'table_historique_eleve': {
			hidden: false,
			colOrder: 8,
			minWidth: TABLE.MIN_WIDTH.NOTES
		}
	})
	resumeNotes: string;


	// libelleMention: string;


	// Données brutes
	examen: any;
	typeNotation: any;
	idProfesseur: any; //utilisé dans onglet bulletin pour savoir si un utilisateur professeur peur modifier le resultat

	// ExamenResultatModel
	constructor(data = null, examen?, typeNotation?, isInitModele = true, isInitData = true, isHistorique = false
		, isDispenseAutorise = false, isJuryLectureAutorisee = false) {
		super();
		//console.log('constructeur ExamenResultatModel', data, examen, typeNotation, isInitModele, isInitData);
		/*console.log(
			{
				ou: 'constructeur ExamenResultatModel',
				data, examen, typeNotation, isInitModele, isInitData, isHistorique
			}
		);*/
		if (!data) {
			return;
		}
		if (isHistorique) {
			this.initModele(this.examen, this.typeNotation, data, isHistorique);
			this.initData(data);
			return;
		}
		if (examen) {
			this.examen = examen;
		} else if (data.examen) {
			this.examen = data.examen;
		}
		if (isInitModele && !this.examen) {
			console.log('examen non present : paramétrage impossible');
			return;
		}
		if (typeNotation) {
			this.typeNotation = typeNotation;
		} else if (isInitModele && this.examen.typeNotation) {
			this.typeNotation = this.examen.typeNotation;
		}
		if (isInitModele && !this.typeNotation) {
			console.log('typeNotation non present : paramétrage impossible');
			return;
		}
		if (isInitModele) {
			this.initModele(this.examen, this.typeNotation, data, isHistorique);
		}
		if (isInitData) {
			this.initData(data);
		}
		this.setIsDispenseAutorise(isDispenseAutorise);
		this.setIsJuryVisible(isJuryLectureAutorisee);
	}
	setIsDispenseAutorise(isDispenseAutorise: boolean = false) {
		this.getEntry('edit', 'isDispense')['options'] = [{
			label: '',
			value: true,
			disabled: !isDispenseAutorise,
		}];
		this.getEntry('table', 'isDispense')['isEditable'] = isDispenseAutorise;
	}
	setIsJuryVisible(isJuryLectureAutorisee: boolean = false) {
		// Masque les enrées concernant le jury si elles ne sont pas dans le paramétrage (examen) et si isJuryLectureAutorisee=false
		const isJuryVisible = this.examen.juryMention && isJuryLectureAutorisee;
		// console.log({ isJuryLectureAutorisee, isJuryVisible });
		// this.getEntry('consult', 'resultatJury').hidden = !isJuryVisible;
		// this.getEntry('edit', 'resultatJury').hidden = !isJuryVisible;
		this.registerEntryDynamicProperty(['edit', 'consult'], 'resultatJury', 'hidden', !isJuryVisible);
		// console.log(this.getEntry('consult', 'resultatJury'));
		// console.log(this.getEntry('consult', 'libre_1'));
	}
	initData(fields: any) {
		//console.log({where: 'initData', fields});
		let examResult = null;
		if (fields['examenResultat']) {
			examResult = fields['examenResultat'];
			if (!examResult.libelleProfessseur) {
				const examenResultatAbsent = fields['examenResultatAbsent'];
				if (examenResultatAbsent) {
					examResult.libelleProfesseur = examenResultatAbsent.libelleProfesseur;
				}
			}
		} else if (fields['examenResultatAbsent']) {
			examResult = fields['examenResultatAbsent'];
		} else {
			examResult = fields;
		}
		if (examResult) {
			// ICI ça doit écraser le modèle des sous-attributs ! => ne pas faire un assign systématique mais faire champ par champ
			// Object.assign(this, examResult);
			this.ptsNextMention = examResult.ptsNextMention;
			this.idProfesseur = fields['idProfesseur'];
			this.isDispense = examResult.isDispense;
			this.isChangementNiveau = examResult.isChangementNiveau;
			this.libre_1 = examResult.libre_1;
			this.commentaire = examResult.commentaire;
			this.isValide = examResult.isValide;
			this.idExamen = examResult.idExamen;
			this.isMentionCalculeeManuel = examResult.isMentionCalculeeManuel;
			if (!this.idExamen) {
				this.idExamen = this.examen.id;
			}
			this.id = examResult.id;
			this.idEleve = examResult.idEleve;
			this.idDiscipline = examResult.idDiscipline;
			this.idCursus = examResult.idCursus;
			this.idCycle = examResult.idCycle;
			this.idNiveau = examResult.idNiveau;
			// idTypeNotation: number;
			this.anneeScolaire = examResult.anneeScolaire;
			if (!this.anneeScolaire) {
				this.anneeScolaire = this.examen.anneeScolaire;
			}
			this.libelleCycle = examResult.libelleCycle;
			this.libelleNiveau = examResult.libelleNiveau;
			this.libelleCycleNiveau = (examResult.libelleCycle ? examResult.libelleCycle + ' - ' : '') + (examResult.libelleNiveau ? examResult.libelleNiveau : "");
			this.nbAnneesDansCycle = examResult.nbAnneesDansCycle;
			this.libelleProfesseur = examResult.libelleProfesseur;
			this.eleveLibelle = examResult.eleveLibelle;
			if (examResult.idFuturCycle) {
				// console.log({ idFuturCycle: examResult.idFuturCycle, idCycle: examResult.idCycle, nbAnneesDansCycle: examResult.nbAnneesDansCycle});
				this.nbAnneesDansCycleAnneeSuivante = (+examResult.idFuturCycle === +examResult.idCycle) ? +this.nbAnneesDansCycle + 1 : 1;
			}  else {
				this.nbAnneesDansCycleAnneeSuivante = null;
			}
			this.libelleFuturNiveau = '';
			if (examResult.libelleFuturCycle) {
				this.libelleFuturNiveau += examResult.libelleFuturCycle;
			}
			if (examResult.libelleFuturNiveau) {
				this.libelleFuturNiveau += '/' + examResult.libelleFuturNiveau;
			}
			for (let indexNoteNumerique: number = 1; indexNoteNumerique <= NB_NOTES_NUMERIQUES; indexNoteNumerique++) {
				const nomChampNote = 'note_' + indexNoteNumerique;
				// console.log('avant initData', nomChampNote, examResult[nomChampNote], this);
				this[nomChampNote] = examResult[nomChampNote];
				// console.log('apres', nomChampNote, examResult[nomChampNote], this);
			}
			const note_totale = 'note_totale';
			this[note_totale] = examResult[note_totale];
			const note_moyenne = 'note_moyenne';
			this[note_moyenne] = examResult[note_moyenne];

			if (this.mention_1) {
				// console.log('initData mention_1', examResult['mention_1']);
				this.mention_1.initData(examResult['mention_1']);
				// console.log('apres initData', this.mention_1);
			}
			if (this.mention_2) {
				this.mention_2.initData(examResult['mention_2']);
			}
			if (this.mention_3) {
				this.mention_3.initData(examResult['mention_3']);
			}
			if (this.mention_4) {
				this.mention_4.initData(examResult['mention_4']);
			}
			if (this.mention_5) {
				this.mention_5.initData(examResult['mention_5']);
			}
			if (this.mention_6) {
				this.mention_6.initData(examResult['mention_6']);
			}
			if (this.mention_7) {
				this.mention_7.initData(examResult['mention_7']);
			}
			if (this.mention_8) {
				this.mention_8.initData(examResult['mention_8']);
			}
			if (this.mention_9) {
				this.mention_9.initData(examResult['mention_9']);
			}
			if (this.mention_10) {
				this.mention_10.initData(examResult['mention_10']);
			}
			if (this.mentionCalculee) {
				this.mentionCalculee.initData(examResult['mentionCalculee']);
			}

			// Traiter les données du jury : examResult['resultatJury']
			const dataJury = examResult['resultatJury'];
			if (this.resultatJury) {
				// console.log(dataJury);
				this.resultatJury.initData(dataJury);
				// const resultatJury = new ExamenResultatJuryModel(dataJury, true);
				// console.log({ ou: 'apres constructeur ExamenResultatJuryModel', resultatJury: this.resultatJury });
				// this.resultatJury.initData(dataJury);
				// this.resultatJury = null;
			}
		}
		if (!this.idCycle && fields['idCycle']) {
			this.idCycle = fields['idCycle'];
		}
		if (!this.idNiveau && fields['idNiveau']) {
			this.idNiveau = fields['idNiveau'];
		}
		// console.log(this);
	}

	initModele(examen, typeNotation, fields: any, isHistorique = false) { // , modeConsult = 'consult'
		/*console.log({
			ou: 'initModele',
			examen, typeNotation, fields, isHistorique
		});*/
		let examResult = null;
		if (fields['examenResultat']) {
			examResult = fields['examenResultat'];
		} else if (fields['examenResultatAbsent']) {
			examResult = fields['examenResultatAbsent'];
		} else {
			examResult = fields;
		}

		if (examen && examen.juryMention && examResult) {
			// console.log({ ou: 'presence de jury', juryMentionn: examen.juryMention, examResult });
			const resultatJury = examResult['resultatJury'];
			this.resultatJury = new ExamenResultatJuryModel(resultatJury, examen, typeNotation, true, false, this);
			this.registerEntryDynamicProperty(['edit', 'consult'], 'resultatJury', 'hidden', false);
			// this.resultatJury.initModele(typeNotation, examen, resultatJury);
		} else {
			// console.log({ ou: 'pas de jury', juryMentionn: examen.juryMention, examResult });
			this.resultatJury = null;
		}

		// Construction des titres
		if (examen) {
			this.libelleDiscipline = (examen.disciplineLibelle) ? examen.disciplineLibelle : examResult.libelleDiscipline;
			this.libelleExamen = ((examen.isExamen) ? 'Examen ' : 'Evaluation ')
				+ examen.libelle
				+ ' - '
				+ (this.libelleDiscipline);
			// TODO Ajouter libellé cycle, niveau, professeur côté serveur pour les ajouter ici
			this.getEntry('table', 'isChangementNiveau').hidden = !examen.isExamen; // Masqué pour les évaluation et affiché pour les examens
			this.getEntry('table', 'libelleFuturNiveau').hidden = !examen.isExamen; // Masqué pour les évaluation et affiché pour les examens
		}
		if (isHistorique) {
			this.libelleExamen = fields.libelleExamen;
			this.resumeNotes = fields.resumeNotes;
			this.libelleDiscipline = fields.libelleDiscipline;
			// Récupération de toutes les notes pour affichage historique sans connaissance du modèle de notation
			/*for (let indexNoteNumerique: number = 1; indexNoteNumerique <= NB_NOTES_NUMERIQUES; indexNoteNumerique++) {
			}*/
			return;
		}
		// Récupération des paramètres de notations
		if (examen && typeNotation) {
			this.idTypeNotation = typeNotation.id;
			// const typeNotation = fields.examen.typeNotation;
			// Notes numériques
			const groupeCourant = null;
			for (let indexNoteNumerique: number = 1; indexNoteNumerique <= NB_NOTES_NUMERIQUES; indexNoteNumerique++) {
				const groupeDeNote: Number = typeNotation['note_' + indexNoteNumerique + '_groupe'];
				if (groupeCourant != groupeDeNote) {
					// TODO au changement de groupe, afficher le libellé du groupe
					// => il faudra certainement se passer de l'auto-form car je ne vois pas comment faire avec
					// refObjectNote = ReferenceHelper.getLibelleNote(groupeDeNote);
					// refObjectNote.libelle
				}

				const nomChampNote = 'note_' + indexNoteNumerique;
				// console.log('getEntry', nomChampNote, typeNotation[nomChampNote]);
				const entryEdit = this.getEntry('edit', nomChampNote);
				const entryConsult = this.getEntry('consult', nomChampNote);
				const entryTable = this.getEntry('table', nomChampNote);
				if (typeNotation[nomChampNote] != null) {
					// Note a un libellé dans le paramétrage => la note doit être renseignée
					// const mention = new ExamenMentionModel();
					const nomChampNoteMax = 'note_' + indexNoteNumerique + '_max';
					const noteMax = typeNotation[nomChampNoteMax];
					const labelNote = typeNotation[nomChampNote] + ' (/' + noteMax + ')';
					entryEdit.label = labelNote;
					entryEdit.hidden = false;
					entryConsult.label = labelNote;
					entryConsult.hidden = false;
					entryTable.label = labelNote;
					entryTable.hidden = false;

					if (!entryEdit.validators) entryEdit.validators = [];
					entryEdit.validators = [...entryEdit.validators, Validators.min(0), Validators.max(noteMax)];
					if (!entryEdit.validatorsMsgs) {
						entryEdit.validatorsMsgs = {};
					}
					entryEdit.validatorsMsgs.min = 'La note doit être comprise entre 0 et ' + noteMax;
					entryEdit.validatorsMsgs.max = 'La note doit être comprise entre 0 et ' + noteMax;

					if (!entryTable.validators) entryTable.validators = [];
					entryTable.validators = [...entryTable.validators, Validators.min(0), Validators.max(noteMax)];
					if (!entryTable.validatorsMsgs) {
						entryTable.validatorsMsgs = {};
					}
					entryTable.validatorsMsgs.min = 'La note doit être comprise entre 0 et ' + noteMax;
					entryTable.validatorsMsgs.max = 'La note doit être comprise entre 0 et ' + noteMax;
				} else {
					entryEdit.hidden = true;
					entryConsult.hidden = true;
					entryTable.hidden = true;
					// console.log(nomChampNote, 'hidden', true);
				}
			}
			// Ligne total
			const isNoteTotalAffichee = (typeNotation['isTotalAffiche'] == true);
			const entryNoteTotaleEdit = this.getEntry('edit', 'note_totale');
			const entryNoteTotaleConsult = this.getEntry('consult', 'note_totale');
			const entryNoteTotaleTable = this.getEntry('table', 'note_totale');
			entryNoteTotaleEdit.hidden = !isNoteTotalAffichee;
			entryNoteTotaleConsult.hidden = !isNoteTotalAffichee;
			entryNoteTotaleTable.hidden = !isNoteTotalAffichee;
			const noteTotaleMax = typeNotation['total_max'];
			const labelNoteTotale = 'Total (/' + noteTotaleMax + ')';
			entryNoteTotaleEdit.label = labelNoteTotale;
			entryNoteTotaleConsult.label = labelNoteTotale;
			entryNoteTotaleTable.label = labelNoteTotale;

			// Ligne moyenne
			const isMoyenneAffichee = (typeNotation['isMoyenneAffichee'] == true);
			const entryMoyenneEdit = this.getEntry('edit', 'note_moyenne');
			const entryMoyenneConsult = this.getEntry('consult', 'note_moyenne');
			const entryMoyenneTable = this.getEntry('table', 'note_moyenne');
			entryMoyenneEdit.hidden = !isMoyenneAffichee;
			entryMoyenneConsult.hidden = !isMoyenneAffichee;
			entryMoyenneTable.hidden = !isMoyenneAffichee;
			const noteMoyenneMax = typeNotation['moyenne_max'];
			const labelMoyenne = 'Moyenne (/' + noteMoyenneMax + ')';
			entryMoyenneEdit.label = labelMoyenne;
			entryMoyenneConsult.label = labelMoyenne;
			entryMoyenneTable.label = labelMoyenne;

			// Mention calculée
			const nomChampMentionCalculee = 'mentionCalculee';
			const isMMentionCaluleeAffichee = (typeNotation['isMentionCalculeeAffichee'] == true);
			this.getEntry('edit', 'mentionCalculee').hidden = !isMMentionCaluleeAffichee;
			this.getEntry('consult', 'mentionCalculee').hidden = !isMMentionCaluleeAffichee;
			this.getEntry('table', 'mentionCalculee').hidden = !isMMentionCaluleeAffichee;
			if (examResult[nomChampMentionCalculee]) {
				const mention = new ExamenMentionModel();
                mention.initModele(-1, typeNotation, nomChampMentionCalculee, examResult[nomChampMentionCalculee]);
                // console.log('MENTION CALCULEEE', mention);
				this[nomChampMentionCalculee] = mention;
			}

			// Notes mentions
			for (var indexNoteMention: number = 1; indexNoteMention <= NB_NOTES_MENTIONS; indexNoteMention++) {
				const nomChampMention = 'mention_' + indexNoteMention;
				const entryMentionCouranteEdit = this.getEntry('edit', nomChampMention);
				const entryMentionCouranteConsult = this.getEntry('consult', nomChampMention);
				const entryMentionCouranteTable = this.getEntry('table', nomChampMention);
				if (typeNotation[nomChampMention] && typeNotation[nomChampMention]>0) { // examResult[nomChampMention]
					entryMentionCouranteEdit.hidden = false;
					entryMentionCouranteConsult.hidden = false;
					entryMentionCouranteTable.hidden = false;
					const mention = new ExamenMentionModel();
					mention.initModele(indexNoteMention, typeNotation, nomChampMention, examResult[nomChampMention], this);
					// NON, ce n'est pas la valeur, on a initialisé le modèle, le nom du champ est initialisé dans initModele
					// ci-dessus en passant this en paramètre. Les données seront initialisées dans initData
					this[nomChampMention] = mention;
				} else {
					// Mention non présente => pas de modèle => on masque le champ
					entryMentionCouranteEdit.hidden = true;
					entryMentionCouranteConsult.hidden = true;
					entryMentionCouranteTable.hidden = true;
				}
			}

			// Zone libre_1
			const labelLibre_1 = typeNotation['libre_1'];
			const isLibre_1Affiche: boolean = labelLibre_1 != null && labelLibre_1.length > 0;
			const entryLibre_1_edit = this.getEntry('edit', 'libre_1');
			entryLibre_1_edit.hidden = !isLibre_1Affiche;
			entryLibre_1_edit.label = labelLibre_1;
			const entryLibre_1_consult = this.getEntry('consult', 'libre_1');
			entryLibre_1_consult.hidden = !isLibre_1Affiche;
			entryLibre_1_consult.label = labelLibre_1;

			// Jury
			//isJuryLectureAutorisee = examen.juryMention!=0 && FonctionnaliteHelper.isLectureAutorisee(FonctionnaliteHelper.MODULE_EXAMEN_JURY);

			// Dispense
			//isModificationDispenseAutorisee = this.isModificationAutorisee && FonctionnaliteHelper.isLectureAutorisee(FonctionnaliteHelper.MODULE_EXAMEN_DISPENSE);

		}
 	}
}

@Form({
	'consult': { // Mode consultation
		// layout: OneColumnLayout,
	},
	'edit': { // Mode modification (création/modification)
		// layout: OneColumnLayout,
	}
})
export class BulletinModel extends BaseModel {
	@Entry({
		base: {
			type: EntryTypes.CARDS,
			mode: CardMode.SHOW,
			model: ExamenResultatModel,
			title: 'Résultats',
			css: {
				box: 'panel panel-default col-xs-6 col-md-4 col-lg-3',
			},
			// nested: true,
			multiple: true,
		},
		'consult': {},
		'edit': {},
	})
	resultatsExamens: ExamenResultatModel[] = [];

	constructor(bulletinsBruts: Array<any>, isDispenseAutorise: boolean = false, isJuryLectureAutorisee: boolean = false) {
		super();
		console.log('constructeur BulletinModel', bulletinsBruts);
		this.resultatsExamens = [];
		const isInitModele = true;
		const isInitData = true;
		const isHistorique = false;
		bulletinsBruts.forEach(data => {
			const result = new ExamenResultatModel(data, null, null, isInitModele, isInitData, isHistorique, isDispenseAutorise, isJuryLectureAutorisee);
			this.resultatsExamens.push(result);
		});
		console.log('objet ExamenResultatModel créé', this);
	}
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/examen/models/examen-resultat.model.ts